import React from 'react';

import { DashboardContentLayout } from '@portals/framework';

import { OrganizationsTable } from './OrganizationsTable';
import { SupportStateProvider } from '../support-overview/SupportStateProvider';

export function Organizations() {
  return (
    <DashboardContentLayout
      pageTitle="Organizations"
      subtitle="Organizations accessible by the current user"
      pos="relative"
    >
      <SupportStateProvider>
        <OrganizationsTable />
      </SupportStateProvider>
    </DashboardContentLayout>
  );
}
